<div [class]="(isHome())?'home-header':'header-line on'" #headerArea>
    <div [class]="(isSeller())?'wrapperMain seller':'wrapperMain'">
        <div class="header" [class]="(hidden())?'hidden':''">
            <div class="d-flex" [class]="(isHome())?'home-inner':''">
                @if (!myKilowant() && !isHome()) {
                <div (click)="goto((linkHome()!=null && linkHome()!='')?linkHome():((isSeller())?'/seller/home':'/user/home'))" class="backbt link"></div>
                }
                @if (myKilowant() && user() && user()!.isAdvisor && client()!=null) {
                <div class="title d-flex link auto" (click)="clientSelectorOpenPopup()">
                    <div class="title-text">{{getUserName()}}</div>
                    <div class="auto switch"></div>
                </div>
                }
                @if (myKilowant() && user() && user()!.isAdvisor && client()==null) {
                <div style="width: 100%">
                    &nbsp;
                </div>
                }

                @if (myKilowant() && user()!=null && !user()!.isAdvisor) {
                @if (hasMultipleCompanies()) {
                <div class="title d-flex link auto" (click)="userCompanySelectorOpenPopup()">
                    <div class="title-text">{{getUserName()}}</div>
                    <div class="auto switch"></div>
                </div>
                }
                @if (!hasMultipleCompanies()) {
                <div class="title auto">
                    <div class="title-text" style="margin-right: 20px;">{{user()!.nameAsClient}}</div>
                </div>
                }
                }

                @if (!isHome() && !myKilowant()) {
                <div class="title auto">{{title()}}</div>
                }
                @if (isHome()) {
                <div class="logo-grey"></div>
                }

                @if (!showClose()) {
                <a class="menu" [class]="(isHome())?'home-menu':''" (click)="toggleSideNav()">
                    <div></div>
                    <div></div>
                    <div></div>
                </a>
                }
                @if (showClose()) {
                <a class="close-icon" style="top: 27px; right: 10px;" (click)="closeClicked()">
                    <div class="line1"><div class="line2"></div></div>
                </a>
                }
            </div>
            @if (isBuyer() && !kilowantU() && showAccountList()) {
            <div class="globalservice" id="abc">
                <div class="mr-50">
                    <kilowant-account-selector></kilowant-account-selector>
                </div>
            </div>
            }
            @if (isHome() && linkHome()!=null && linkHome()!='') {
            <div class="d-flex home-inner notop">
                <div (click)="goto(linkHome())" class="backbt link"></div>
                <div class="title auto">{{title()}}</div>
            </div>
            }
        </div>
    </div>
</div>